// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2F6pg","footer":"styles_footer__CcAOH","passCodeTooltip":"styles_passCodeTooltip__2XUQr"};